<template lang="pug">
.layout
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card(min-height="80vh")
      v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
        v-row(no-gutters, align="center")
          v-col.shrink
            v-btn.ml-n3(text, icon, @click="showModal = !showModal", height)
              eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text Schedule Reminder
      v-card-text(id="mainContainer")
        credit-alert(:credit="creditBalance" :showTitle="true")
        .main-container(style="margin:0 -24px" v-if="type === null" )
          v-tabs(v-model="selectedType" fixed-tabs color="textColorAccent" height="40" :background-color="$vuetify.theme.themes[$theme].basic100")
            v-tab.button-AA-medium(style="border-bottom: 2px solid var(--v-basic600T16);") income
            v-tab.button-AA-medium(style="border-bottom: 2px solid var(--v-basic600T16);") expense
          div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
        v-form(ref="form")
          v-row.py-2.px-3(style="margin:0 -23px; border-bottom:1px solid var(--v-basic400)")
            v-col(v-if="form.type == 'income'" )
              .label.basic600--text.text-uppercase(id="formDataCategory") income invoice
              v-select.my-2(v-model="form.invoices" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="form.invoices" :menu-props="({'closeOnContentClick': false})" placeholder="Add Income Invoices" :loading="invoicesSearchLoading" ref="selectInvoices" type="button" append-icon="")
                template(v-slot:selection="{ attrs, item, select, selected }")
                  v-chip.my-1.s2(v-if="form.invoices.length > 1" outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close color="basic600" :input-value="selected" @click:close="removeInvoice(item)")
                    span(v-if="item.name") {{`#${item.rid}`}} {{ item.name.length > 8 ? (item.name.substr(0,8) + '...') : item.name }}
                  .s1.basic800--text(v-else) {{`#${item.rid}`}} {{ item.name }}
                template(v-slot:append v-if="type === null")
                  eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="showAttachInvoiceDialog = true")
            v-col(v-else )
              .label.basic600--text.text-uppercase(id="formDataCategory") expense
              v-select.my-2(v-model="form.invoices" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="form.invoices" :menu-props="({'closeOnContentClick': false})" placeholder="Add Expenses" :loading="invoicesSearchLoading" ref="selectInvoices" type="button" append-icon="")
                template(v-slot:selection="{ attrs, item, select, selected }")
                  v-chip.my-1.s2(v-if="form.invoices.length > 1" outlined :style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" close-icon="mdi-close" v-bind="attrs" small close color="basic600" :input-value="selected" @click:close="removeInvoice(item)")
                    span() {{ shortDescription(item.items) }}
                  .s1.basic800--text(v-else) {{ shortDescription(item.items) }}
                template(v-slot:append v-if="type === null")
                  eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="showAttachExpenseDialog = true")
          v-row.py-2.px-3(style="margin:0 -23px; border-bottom:1px solid var(--v-basic400)")
            v-col
              div.s1.textColorDefault--text When should we send this reminder?
              v-row
                v-col
                  .label.basic600--text.text-uppercase Send this reminder
                  v-select.mt-2(v-model="form.repeat" background-color="basic200" outlined dense hide-no-data hide-details :items="repeatChoices" item-text="name" item-value="id")
                    template(v-slot:append)
                      eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-row
                v-col.py-2(cols="6")
                  .label.basic600--text.text-uppercase Starting
                  v-dialog(v-model='form.startingDialog.show' width='290px')
                    template(v-slot:activator='{ on }')
                      v-text-field.mt-2(:value="form.startingDialog.value" background-color="basic200" outlined dense readonly v-on='on' hide-details)
                        template(v-slot:append)
                          eva-icon(name="chevron-down-oustline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                    v-date-picker(v-model='form.start_date' color="primary" no-title @change="saveStartingDate()")
                v-col.py-2(cols="6")
                  .label.basic600--text.text-uppercase Until
                  v-dialog(v-model='form.showUntilDialog' width='290px')
                    v-date-picker(v-model='form.end_date' color="primary" no-title @change="form.showUntilDialog = false")
                  v-select.mt-2(v-model="form.end_date" background-color="basic200" outlined dense hide-no-data hide-details :items="untilChoices" item-text="name" item-value="id")
                    template(v-slot:append)
                      eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-row
                v-col.py-2(cols="6")
                  y-dialog(v-model='form.sendTime.show' width='290px')
                    template(v-slot:activator='{ on }')
                      .label.basic600--text.text-uppercase At
                      v-text-field.mt-2(:value="form.sendTime.time" background-color="basic200" outlined dense readonly v-on='on' hide-details)
                        template(v-slot:append)
                          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                    v-time-picker.elevation-2(v-model='form.send_time' @change="saveSendTime()" color="textColorAccent")
                v-col.py-2.align-self-center.mt-4(cols="6")
                  //- v-btn.elevation-0.pa-0(
                  //-   text,
                  //-   color="transparent",
                  //-   :ripple="false",
                  //-   x-small,
                  //-   light,
                  //-   @click="",
                  //- )
                  //-   eva-icon(
                  //-     name="eye-outline",
                  //-     :fill="$vuetify.theme.themes[$theme].info500",
                  //-     height="15"
                  //-   )
                  //-   .button-Aa-small.info500--text.text-capitalize Preview Schedule
          v-row.py-2.px-3(style="margin:0 -23px; border-bottom:1px solid var(--v-basic400)")
            v-col
              div.s1.textColorDefault--text(id="formDataChannels") How would you like us to send this reminder?
              div.p2.primary400--text Please ensure you have enough balance to send reminders.
              //- div.d-flex.mt-4
              //-   y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="whatsapp")
              //-     template(v-slot:label)
              //-       .p1.textColorDefault--text WhatsApp message sent from Yezza
              div.d-flex.mt-4
                y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="sms")
                  template(v-slot:label)
                    .p1.textColorDefault--text SMS sent from Yezza ({{ channelPrice.sms | displayPrice }})
              div.d-flex.mt-4
                y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="email")
                  template(v-slot:label)
                    .p1.textColorDefault--text Email sent from Yezza
              //- div.d-flex.mt-4
              //-   y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="call")
              //-     template(v-slot:label)
              //-       .p1.textColorDefault--text Automated call
              div.d-flex.mt-4(v-if="form.type == 'expense'")
                y-checkbox.ma-0.pa-0(v-model="form.selectedChannels" hide-details value="in-app")
                  template(v-slot:label)
                    .p1.textColorDefault--text In-app notifications
          v-row.py-2.px-3(v-if="form.type == 'income'")
            div.d-flex.align-center.my-3
              div.mr-2.p2.primary500--text Send message in 
              v-menu(left :offset-y='true')
                template(v-slot:activator='{ on }')
                  v-chip.px-3(color="basic300" small label v-on="on")
                    div.button-AA-tiny.primary--text.text-uppercase {{ getFormLanguageDisplay() }}
                    v-icon.ml-1(right small) mdi-chevron-down
                v-list
                  v-list-item.my-n2(v-for="(language, index) in languages" :key="language.id" @click="form.language = language.id")
                    v-list-item-title.p2 {{ language.name }}
            v-card( flat outlined width="100%")
              v-card-text.pa-3
                div.s1.basic1000--text Message preview:
                linkify-text.p1.primary400--text.mt-2(:text="formattedMessage(messagePreview, null)")
            //- v-btn.mx-3.button-Aa-small.custom-transform-class.text-none.px-2.mt-4(color="textColorAccent" text @click="showMessageTemplateDialog = true" small)
            //-       eva-icon.mt-1.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
            //-       | Customize message
              
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = !showModal')
          .button-Aa-medium.primary400--text Cancel
        v-btn.mr-2(color='info500' depressed @click="sendReminder" :loading="isLoading")
          .button-AA-medium.basic100--text Send
  .modals
    add-message-template(v-if="showMessageTemplateDialog" :open.sync="showMessageTemplateDialog" :message.sync="messageTemplate")
    attach-invoice(v-if="showAttachInvoiceDialog" :open.sync="showAttachInvoiceDialog" :initialInvoices.sync="form.invoices")
    attach-expense(v-if="showAttachExpenseDialog" :open.sync="showAttachExpenseDialog" :initialExpenses.sync="form.invoices")
    low-balance(:open.sync="openLowBalanceDialog" :amount.sync="insufficientAmount")
    incomplete-info(v-if="openIncompleteDialog" :open.sync="openIncompleteDialog" :initialInvoices.sync="editIncompleteInvoices" :invoices="form.invoices" :channels="form.selectedChannels" @updated="handleUpdatedInfo")
</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'
import AddMessageTemplate from '@/components/yezzabook/dialogs/AddMessageTemplate.vue'
import AttachInvoice from '@/components/yezzabook/dialogs/AttachInvoices.vue'
import AttachExpense from '@/components/yezzabook/dialogs/AttachExpense.vue'
import IncompleteInfo from '@/components/yezzabook/dialogs/IncompleteInfo.vue'
import LowBalance from '@/components/yezzabook/dialogs/LowBalance.vue'
import LinkifyText from '@/components/LinkifyText.vue'

export default {
  components:{CreditAlert, AttachInvoice, AttachExpense, AddMessageTemplate, IncompleteInfo, LowBalance, LinkifyText},
  props: ["open", "type", "selectedInvoices", "useStorage"],
  data: () => ({
    showAttachInvoiceDialog: false,
    showAttachExpenseDialog: false,
    showMessageTemplateDialog: false,
    openLowBalanceDialog: false,
    openIncompleteDialog: false,
    editIncompleteInvoices: [],
    selectedType: 0,
    form: {
      type: 'income',
      invoices:[],
      selectedChannels: [],
      language: 'en',
      repeat: 'weekly',
      start_date: null,
      startingDialog: {
        show: false,
        value: null
      },
      end_date: null,
      showUntilDialog: false,
      send_time: null,
      sendTime: {
        time: null,
        show: false
      }
    },
    invoicesSearchLoading: false,
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' },
      // { name: 'Chinese', id: 'zh' },
      // { name: 'Tamil', id: 'ta' },
    ],
    repeatChoices: [
      { name: 'Daily', id: 'daily'},
      { name: 'Once a week', id: 'weekly'},
      { name: 'Once a month', id: 'monthly'}
    ],
    untilChoices: [
      { name: 'Payment made', id: null },
      { name: 'Custom', id: 'custom'}
    ],
    isLoadingContact: false,
    isLoading: false,
    options: {
      duration: 200,
      offset: 0,
      easing: 'linear',
      container: '#mainContainer'
    },
    channelPrice: {
      sms: 20
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  mounted(){
    if (this.type) {
      this.selectedType = this.type === 'income' ? 0 : 1
    }
    this.form.start_date = DateTime.local().toFormat('yyyy-MM-dd')
    this.form.startingDialog.value = this.formatDate(this.form.start_date)
    this.form.send_time = DateTime.local().toFormat('HH:mm')
    this.form.sendTime.time = this.formatTime(this.form.send_time)
    this.form.invoices = this.selectedInvoices || []
    if (this.useStorage && this.$store.state.reminder.data && this.$store.state.reminder.data.type === this.reminder.type) {
      this.form = this.$store.state.reminder.data.form
    }
    this.$store.commit('reminder/setReminder', null)
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    reminder () {
      return {
        type: 'schedule',
        form: this.form
      }
    },
    firstInvoice() {
      if (this.form.invoices.length == 0) {
        return null
      }
      return this.form.invoices[0]
    },
    creditBalance () {
      return this.company.prepaid_credits
    },
    insufficientAmount () {
      let price = 0
      const count = this.form.invoices.length
      if (this.form.selectedChannels.includes('sms')) {
        price += this.channelPrice.sms * count
      }
      const amount = this.creditBalance - price
      return amount < 0 ? Math.abs(amount) : 0
    },
    incompleteInvoices() {
      let invoices = []
      if (this.form.selectedChannels.includes('email') && this.form.selectedChannels.length >= 2) {
        invoices = this.form.invoices.filter(f => !f.email || !f.phone)
      } else if (this.form.selectedChannels.includes('email')) {
        invoices = this.form.invoices.filter(f => !f.email)
      } else {
        invoices = this.form.invoices.filter(f => !f.phone)
      }
      for (let i = 0; i < invoices.length; i++) {
        invoices[i].checked = true
      }
      return invoices
    },
    messagePreview () {
      return this.$t('template_message')
    },
    messageTitle() {
      return this.$t('template_title')
    }
  },
  watch: {
    invoices () {
      this.$emit("updateSelected", this.form.invoices)
    },
    // 'form.language' (val) {
    //   this.$i18n.locale = val
    // },
    'form.end_date' (val) {
      if (val === 'custom') {
        this.form.showUntilDialog = true
        this.form.end_date = DateTime.local().toFormat('yyyy-MM-dd')
      }
      if (val) {
        this.untilChoices = [
          { name: 'Payment made', id: null },
          { name: this.formatDate(this.form.end_date), id: this.form.end_date},
          { name: 'Custom', id: 'custom'}
        ]
        console.log(this.untilChoices)
      } else {
        this.untilChoices = [
          { name: 'Payment made', id: null },
          { name: 'Custom', id: 'custom'}
        ]
      }
    },
    selectedType (val) {
      if (!this.type) {
        this.form.invoices = []
      }
      if (val === 0) {
        this.form.type = 'income'
        if (this.form.selectedChannels.includes('in-app')) {
          this.form.selectedChannels = this.form.selectedChannels.filter((channel) => channel !== 'in-app')
        }
      } else {
        this.form.type = 'expense'
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    shortDescription(items){
      var length = items.length;
      if (length == 0) {
        return 'Null'
      }
      return this.textLimit(items[0].description,10)
    },textLimit(text,max){
      if (text.length > max && this.$vuetify.breakpoint.width < 411 && this.$vuetify.breakpoint.width > 330) {
        return `${text.substring(0, max - 1)}...`
      }else if (text.length > max && this.$vuetify.breakpoint.width < 340) {
        return `${text.substring(0, max - 6)}...`
      }
      return text
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getFormLanguageDisplay () {
      const selectedLanguage = this.languages.filter((obj) => {
        return obj.id == this.form.language
      })
      if (selectedLanguage.length > 0) {
        return selectedLanguage[0].name
      }
      return this.form.language
    },
    handleUpdatedInfo () {
      this.sendReminder()
    },
    saveStartingDate () {
      this.form.startingDialog.show = false
      this.form.startingDialog.value = this.formatDate(this.form.start_date)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    saveSendTime () {
      this.form.sendTime.time = this.formatTime(this.form.send_time)
      this.form.sendTime.show = false
    },
    formatTime (time24) {
      let ts = time24
      const H = + ts.substr(0, 2)
      let h = (H % 12) || 12
      h = (h < 10) ? ('0' + h) : h
      const ampm = H < 12 ? 'AM' : 'PM'
      ts = h + ':' + ts.substr(3, 2) + ampm
      return ts
    },
    async sendReminder () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.form.invoices.length == 0) {
        this.showMessage(['error', `${this.$options.filters.capitalize(this.form.type)} is required`])
        this.$vuetify.goTo('#formDataInvoices', this.options)
        return
      }
      if (this.form.selectedChannels.length == 0) {
        this.showMessage(['error', this.$t('error_message.reminder_channel_required')])
        this.$vuetify.goTo('#formDataInvoices', this.options)
        return
      }
      if (this.incompleteInvoices.length != 0 && this.form.type === 'income') {
        this.editIncompleteInvoices = [ ...this.incompleteInvoices ]
        this.openIncompleteDialog = true
        return
      }
      if (this.insufficientAmount) {
        this.openLowBalanceDialog = true
        return
      }
      this.isLoading = true
      let hasError = false
      let initialInvoices = [ ...this.form.invoices ]
      await this.asyncForEach(this.form.invoices, async (invoice) => {
        try {
          const data = {
            channels: this.form.selectedChannels.map(m => m),
            language: this.form.language,
            start_date: this.form.start_date,
            send_time: `${this.form.send_time}:00`,
            end_date: this.form.end_date,
            repeat: this.form.repeat
          }
          if (this.form.type === 'income') {
            data.income = invoice.id
          } else {
            data.expense = invoice.id
          }
          console.log(data);
          await this.$axios.post(`/books/${this.company.slug}/scheduled_reminders`, data)
          initialInvoices = initialInvoices.filter((x) => x.pid !== invoice.pid)
        } catch (error) {
          hasError = true
        }
      })
      this.$emit("updateSelected", initialInvoices)
      this.isLoading = false
      if (hasError) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      this.fetchCompany()
      this.showModal = false
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.reminder_sent')])
          this.updateCompany(resp.data)
        }).catch(() => {})
    },
    removeInvoice (item) {
      let index = this.form.invoices.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.form.invoices.splice(index, 1)
      this.$refs.selectInvoices.isMenuActive = false
      this.$emit('updateSelected', item)
    },
    formattedMessage (message, invoice) {
      let displayInvoice = invoice
      if (!displayInvoice) { displayInvoice = this.firstInvoice }
      message = message.split('{{company_name}}').join(this.company.name)
      if (displayInvoice) {
        message = message.split('{{customer_name}}').join(displayInvoice.name)
        message = message.split('{{amount_due}}').join(this.$options.filters.displayPrice(displayInvoice.amount_remaining))
        message = message.split('{{due_date}}').join(this.$options.filters.displayDate(displayInvoice.due_date))
        message = message.split('{{invoice_url}}').join(this.getShareLinkURL(displayInvoice))
      }
      return message
    },
    getShareLinkURL (invoice) {
      return `${process.env.VUE_APP_SHORT_URL_DOMAIN}/v/${invoice.pid}`
    }
  }
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "template_title": "Invoice reminder from {{company_name}}",
    "template_message": "Hi {{customer_name}},\n\nYour payment of {{amount_due}} to {{company_name}} is due on {{due_date}}.\nView & pay here:\n{{invoice_url}}\n\nThank you.",
    "email": {
      "label": "Email",
      "placeholder": "Email address"
    },
    "add": "Add",
    "save": "Save"
  },
  "ms": {
    "template_title": "Peringatan invois dari {{company_name}}",
    "template_message": "Hi {{customer_name}},\n\nBaki invois sebanyak {{amount_due}} kepada {{company_name}}. Sila buat pembayaran sebelum {{due_date}}.\nSemak & bayar di sini:\n{{invoice_url}}\n\nTerima kasih.",
    "email": {
      "label": "Email",
      "placeholder": "Email address"
    },
    "add": "Add",
    "save": "Save"
  }
}
</i18n>